import { AxiosRequestConfig } from "axios";
import client from "../../ApiService";
import HttpClient from "../../http-client";

class _BasicApi {
  public client: HttpClient;
  public constructor(client: HttpClient) {
    this.client = client;
  }
}

const baseUri = "/meeting-room";
class _MeetingRoomApi extends _BasicApi {
  // Event 목록 조회
  async getMeetingRoomEvents<T>(params: any): Promise<T> {
    const config: AxiosRequestConfig = { params };
    const response = await this.client.get<T>(`${baseUri}/events`, config);
    return response.data as any;
  }

  // 회의실 정보 목록 조회
  async getMeetingRoomList<T>(params = { location: "all" }): Promise<T> {
    const config: AxiosRequestConfig = { params };
    const response = await this.client.get<T>(`${baseUri}/list`, config);
    return response.data;
  }
}

export const MeetingRoomApi = new _MeetingRoomApi(client);
